module.exports = __webpack_public_path__ + "img/teacherList_cn.b2c6f575.png";